import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const PAUSE_RESUME_DISABLED_STATES: Set<CubiqTS.OrderState> = new Set([
  CubiqTS.OrderState.ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.CANCEL_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.CANCEL_PENDING_FWDS,
  CubiqTS.OrderState.CANCELLED,
  CubiqTS.OrderState.EXPIRED,
  CubiqTS.OrderState.EXPIRY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.EXPIRY_PENDING_FWDS,
  CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.FILL_ERROR,
  CubiqTS.OrderState.FILL_EXPIRED,
  CubiqTS.OrderState.FILLED,
  CubiqTS.OrderState.MIGRATION_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.PENDING_FWDS,
  CubiqTS.OrderState.REJECTED,
  CubiqTS.OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED,
  CubiqTS.OrderState.TRIGGERED,
  CubiqTS.OrderState.MANUAL_PRICING,
]);

/**
 * what type of Pause is supported by the order
 */
export enum PausableOrderType {
  NONE,
  LIMIT,
  ALGO,
}
export class OrderPauseState {
  /**
   * Orders in Acceptance are not Pause/Resume Eligible
   */
  public static isEnabledOrderState(order: CubiqTS.OrderData) {
    return PAUSE_RESUME_DISABLED_STATES.has(order.orderState) === false;
  }

  public static isDisabledOrderState(order: CubiqTS.OrderData) {
    return PAUSE_RESUME_DISABLED_STATES.has(order.orderState);
  }

  public static isResumableOrder(order: CubiqTS.OrderData) {
    return (
      order != null &&
      OrderPauseState.isPausableOrderType(order.orderType) &&
      CubiqTS.PauseState.PAUSED === order.pauseState &&
      OrderPauseState.isEnabledOrderState(order)
    );
  }

  public static isPausableOrder(order: CubiqTS.OrderData) {
    return (
      order != null &&
      OrderPauseState.isPausableOrderType(order.orderType) &&
      (order.pauseState == null || CubiqTS.PauseState.NOT_PAUSED === order.pauseState) &&
      OrderPauseState.isEnabledOrderState(order)
    );
  }

  /**
   * Does this order type support Pause/Resume?
   * @param orderType
   * @returns
   */
  public static isPausableOrderType(orderType: CubiqTS.OrderType): boolean {
    return this.getPausableOrderType(orderType) !== PausableOrderType.NONE;
  }

  /**
   *Return the type of Pause supported by order type
   * @param orderType
   * @returns
   */
  public static getPausableOrderType(orderType: CubiqTS.OrderType): PausableOrderType {
    switch (orderType) {
      case CubiqTS.OrderType.LIMIT_TP:
      case CubiqTS.OrderType.LIMIT_SL:
      case CubiqTS.OrderType.LIMIT_CALL:
      // Markets types are added as support them for optimisitic checks
      case CubiqTS.OrderType.MARKET:
      case CubiqTS.OrderType.MARKET_FOK:
      case CubiqTS.OrderType.MARKET_IOC:
        return PausableOrderType.LIMIT;
      case CubiqTS.OrderType.BMALGO:
      case CubiqTS.OrderType.ALGO:
        return PausableOrderType.ALGO;
      default:
        return PausableOrderType.NONE;
    }
  }

  public static isPausedOrderState(order: CubiqTS.OrderData) {
    return (
      OrderPauseState.isEnabledOrderState(order) &&
      order != null &&
      order.pauseState != null &&
      (CubiqTS.PauseState.PAUSED === order.pauseState ||
        CubiqTS.PauseState.RESUME_PENDING === order.pauseState)
    );
  }

  public static isPausePendingOrderState(order: CubiqTS.OrderData) {
    return (
      OrderPauseState.isEnabledOrderState(order) &&
      order != null &&
      order.pauseState != null &&
      CubiqTS.PauseState.PAUSE_PENDING === order.pauseState
    );
  }

  public static isResumePendingOrderState(order: CubiqTS.OrderData) {
    return (
      OrderPauseState.isEnabledOrderState(order) &&
      order != null &&
      order.pauseState != null &&
      CubiqTS.PauseState.RESUME_PENDING === order.pauseState
    );
  }

  // TODO add other Pause/Resume related rules here
}
